import axios from '@/utilities/axios-global'

export function GET_CONTACTS(context, payload) {
  return new Promise((resolve, reject) => {
    axios.post(context.rootState.user.baseApiUrl + '/useradmin/contactlist', payload).then(response => {
      context.commit('SET_CONTACTS', response.data)
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function GET_REBUTTAL_USERS(context, payload) {
  return new Promise((resolve, reject) => {
    axios.post(context.rootState.user.baseApiUrl + '/useradmin/contactlist?rebuttalUsersOnly=true', payload).then(response => {
      context.commit('SET_CONTACTS', response.data)
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function GET_CONTACT(context, id) {
  return new Promise((resolve, reject) => {
    let url = context.rootState.user.baseApiUrl + '/useradmin/contact/' + id
    axios.get(url).then((response) => {
      context.commit('SET_CONTACT', response.data)
      resolve(true)
    }, (err) => {
      console.log(err)
      reject(err)
    })
  })
}

const POST_CONTACT = (context, payload) => {
  return new Promise((resolve, reject) => {
    let url = context.rootState.user.baseApiUrl + '/useradmin/contact/' + payload.emailAddress
    axios.post(url, payload).then(response => {
      context.commit('SET_CONTACT', response.data)
      resolve(response.data)
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

const PUT_CONTACT = (context, user) => {
  return new Promise((resolve, reject) => {
    let url = context.rootState.user.baseApiUrl + '/useradmin/contact/' + user.id
    axios.put(url, user).then((response) => {
      context.commit('SET_CONTACT', response.data)
      resolve(true)
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function GET_PW_RESET_TICKET(context, auth0UserId) {
  return new Promise((resolve, reject) => {
    let url = context.rootState.user.baseApiUrl + '/useradmin/contact/pw-reset-ticket?auth0UserId=' + auth0UserId
    axios.get(url).then((response) => {
      context.commit('SET_PW_RESET_TICKET', response.data.ticket)
      resolve(true)
    }, (err) => {
      console.log(err)
      reject(err)
    })
  })
}

const POST_PW_RESET_EMAIL = (context, user) => {
  return new Promise((resolve, reject) => {
    let url = context.rootState.user.baseApiUrl + '/useradmin/contact/pw-reset-email?email=' + user.emailAddress
    axios.post(url, user).then((response) => {
      resolve(response.data)
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function GET_CONTACTROLES(context, id) {
  return new Promise((resolve, reject) => {
    let url = context.rootState.user.baseApiUrl + '/useradmin/contact/roles'
    axios.get(url).then((response) => {
      context.commit('SET_CONTACTROLES', response.data)
      resolve(true)
    }, (err) => {
      console.log(err)
      reject(err)
    })
  })
}

export function POST_CONTACT_ROLE(context, payload) {
  return new Promise((resolve, reject) => {
    let url = context.rootState.user.baseApiUrl + `/useradmin/contact/contactroles`
    axios.post(url, payload).then((response) => {
      context.commit('PUSH_CONTACT_ROLE', response.data)
      resolve(true)
    }, (err) => {
      console.log(err)
      reject(err)
    })
  })
}

export function POST_CONTACT_ROLE_MULTIPLE(context, payload) {
  return new Promise((resolve, reject) => {
    let url = context.rootState.user.baseApiUrl + `/useradmin/contact/contactroles`
    axios.post(url, payload).then((response) => {
      context.commit('CONCAT_CONTACT_ROLES', response.data)
      resolve(response.data)
    }, (err) => {
      console.log(err)
      reject(err)
    })
  })
}

export function POST_MASSUPDATE_CONTACT_ROLE_MULTIPLE(context, payload) {
  return new Promise((resolve, reject) => {
    let url = context.rootState.user.baseApiUrl + `/useradmin/contact/massupdatecontactroles`
    axios.post(url, payload).then((response) => {
      context.commit('SET_MASSUPDATE_CONTACTROLES', response.data)
      resolve(response.data)
    }, (err) => {
      console.log(err)
      reject(err)
    })
  })
}

export function DELETE_CONTACT_ROLE_MULTIPLE(context, payload) {
  return new Promise((resolve, reject) => {
    let url = context.rootState.user.baseApiUrl + `/useradmin/contact/contactroles`
    axios.delete(url, { data: payload }).then(() => {
      payload.forEach(x => {
        context.commit('SPLICE_CONTACT_ROLE', x.id)
      })
      resolve(true)
    }, (err) => {
      console.log(err)
      reject(err)
    })
  })
}

export default {
  GET_CONTACTS,
  GET_CONTACT,
  PUT_CONTACT,
  GET_PW_RESET_TICKET,
  POST_PW_RESET_EMAIL,
  GET_CONTACTROLES,
  POST_CONTACT_ROLE,
  DELETE_CONTACT_ROLE_MULTIPLE,
  POST_CONTACT,
  POST_CONTACT_ROLE_MULTIPLE,
  POST_MASSUPDATE_CONTACT_ROLE_MULTIPLE,
  GET_REBUTTAL_USERS
}
